/* AramCrochet cart drawer (opens from the header cart icon and after "Add to cart"). */
(function () {
  if (window.PCCartDrawer) return;

  /* ---------- money, using the store's own format ---------- */
  function fmt(cents, withCode) {
    var f = (withCode ? window.acMoneyCode : window.acMoney) || window.acMoney || '{{amount}}';
    cents = Math.round(Number(cents) || 0);
    function num(n, d, ts, ds) {
      var s = (n / 100).toFixed(d).split('.');
      s[0] = s[0].replace(/\B(?=(\d{3})+(?!\d))/g, ts);
      return s[1] ? s[0] + ds + s[1] : s[0];
    }
    return f.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
      switch (k) {
        case 'amount_no_decimals': return num(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return num(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return num(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return num(cents, 2, "'", '.');
        case 'amount_with_space_separator': return num(cents, 2, ' ', ',');
        default: return num(cents, 2, ',', '.');
      }
    });
  }

  var PH = 'data:image/svg+xml;utf8,' + encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><rect width="100" height="100" fill="#fdf3f6"/><circle cx="50" cy="50" r="18" fill="none" stroke="#d85f88" stroke-width="3"/><path d="M34 46c10-5 22-4 32 3M33 55c11-5 23-4 34 3" stroke="#d85f88" stroke-width="2.4" fill="none" stroke-linecap="round"/></svg>');
  var I = {
    close: '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"><path d="M6 6l12 12M18 6 6 18"/></svg>',
    minus: '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"><path d="M5 12h14"/></svg>',
    plus: '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"><path d="M12 5v14M5 12h14"/></svg>',
    tag: '<svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M20 12a8 8 0 0 1-13.7 5.6M4 12A8 8 0 0 1 17.7 6.4"/><path d="M18 3v3.6h-3.6M6 21v-3.6h3.6"/></svg>',
    download: '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M12 4v11"/><path d="m7 10 5 5 5-5"/><path d="M5 19h14"/></svg>',
    infinity: '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M12 12c-2-2.7-3.6-4-5.5-4a4 4 0 1 0 0 8c1.9 0 3.5-1.3 5.5-4zm0 0c2 2.7 3.6 4 5.5 4a4 4 0 1 0 0-8c-1.9 0-3.5 1.3-5.5 4z"/></svg>',
    shield: '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M12 21s7-3.5 7-9.5V5.5L12 3 5 5.5v6C5 17.5 12 21 12 21z"/></svg>'
  };
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function sized(src, w) { return src ? src.replace(/(\.[a-zA-Z]+)(\?|$)/, '_' + w + 'x$2') : ''; }
  function thumb(src, alt) {
    return '<span class="pc-cd-thumb"><img src="' + (sized(src, 200) || PH) + '" alt="' + esc(alt) + '" loading="lazy" onerror="this.onerror=null;this.src=\'' + PH + '\'"></span>';
  }

  /* compare-at prices are not in /cart.js, so read them from each product once */
  var productCache = {};
  function loadProduct(handle) {
    if (!productCache[handle]) {
      productCache[handle] = fetch('/products/' + handle + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    }
    return productCache[handle];
  }
  function withCompare(cart) {
    var handles = [];
    cart.items.forEach(function (i) { if (handles.indexOf(i.handle) < 0) handles.push(i.handle); });
    return Promise.all(handles.map(loadProduct)).then(function (products) {
      var byVariant = {};
      products.forEach(function (p) { if (p) p.variants.forEach(function (v) { byVariant[v.id] = { compare: v.compare_at_price || 0, type: p.type }; }); });
      cart.items.forEach(function (i) {
        var info = byVariant[i.variant_id] || {};
        var unitCompare = Math.max(info.compare || 0, i.original_price || 0);
        i._compare_line = unitCompare * i.quantity;
        i._type = info.type || i.product_type || '';
      });
      return cart;
    });
  }

  /* ---------- drawer shell ---------- */
  function ensure() {
    var o = document.getElementById('pc-cd-overlay');
    if (o) return o;
    o = document.createElement('div');
    o.id = 'pc-cd-overlay';
    o.className = 'pc-cd-overlay';
    o.innerHTML =
      '<div class="pc-cd-drawer" role="dialog" aria-modal="true" aria-labelledby="pc-cd-title">' +
        '<div class="pc-cd-header"><h3 id="pc-cd-title">Your cart <span class="pc-cd-count">0</span></h3>' +
        '<button type="button" class="pc-cd-close" aria-label="Close cart">' + I.close + '</button></div>' +
        '<div class="pc-cd-shipping"><p class="pc-cd-shipping-text">Instant download &mdash; no shipping needed</p><div class="pc-cd-bar"><span></span></div></div>' +
        '<div class="pc-cd-items"><div class="pc-cd-list"></div>' +
          '<div class="pc-cd-recs" hidden><p class="pc-cd-recs-title">You might also like</p><div class="pc-cd-recs-track"></div><div class="pc-cd-recs-dots"></div></div>' +
        '</div>' +
        '<div class="pc-cd-footer">' +
          '<div class="pc-cd-subtotal-row"><span class="pc-cd-subtotal-label">Subtotal</span><span class="pc-cd-saved" hidden></span><span class="pc-cd-subtotal"></span></div>' +
          '<a href="/checkout" class="pc-cd-checkout">Checkout</a>' +
          '<div class="pc-cd-trust-row">' +
            '<span class="pc-cd-trust-item">' + I.download + 'Instant download</span>' +
            '<span class="pc-cd-trust-item">' + I.infinity + 'Lifetime access</span>' +
            '<span class="pc-cd-trust-item">' + I.shield + 'Secure checkout</span>' +
          '</div>' +
          '<p class="pc-cd-trust">Taxes and discounts calculated at checkout.</p>' +
        '</div>' +
      '</div>';
    document.body.appendChild(o);
    o.addEventListener('click', function (e) { if (e.target === o || e.target.closest('.pc-cd-close')) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && o.classList.contains('is-open')) close(); });
    return o;
  }
  function close() {
    var o = document.getElementById('pc-cd-overlay');
    if (o) o.classList.remove('is-open');
    document.documentElement.style.overflow = '';
  }

  /* header bubble */
  function syncBubble(count) {
    document.querySelectorAll('.cart-bubble__text-count').forEach(function (el) {
      el.textContent = count > 0 ? count : '';
      el.classList.toggle('hidden', !count);
    });
    document.querySelectorAll('.cart-bubble').forEach(function (el) { el.classList.toggle('visually-hidden', !count); });
    document.querySelectorAll('.header-actions__cart-icon').forEach(function (el) { el.classList.toggle('header-actions__cart-icon--has-cart', !!count); });
  }

  /* ---------- render ---------- */
  function render(cart) {
    var o = ensure();
    var list = o.querySelector('.pc-cd-list');
    o.querySelector('.pc-cd-count').textContent = cart.item_count;
    o.querySelector('.pc-cd-items').classList.remove('is-busy');
    syncBubble(cart.item_count);

    var footer = o.querySelector('.pc-cd-footer');
    if (!cart.items.length) {
      list.innerHTML = '<div class="pc-cd-empty"><p>Your cart is empty.</p><a href="/collections/all">Shop Patterns</a></div>';
      footer.hidden = true;
      o.querySelector('.pc-cd-recs').hidden = true;
      return;
    }
    footer.hidden = false;

    var saved = 0;
    list.innerHTML = cart.items.map(function (i) {
      var compare = i._compare_line || 0;
      var price = i.final_line_price;
      if (compare > price) saved += compare - price;
      var sub = (i.variant_title && i.variant_title !== 'Default Title') ? i.variant_title : (i._type || '');
      var pct = compare > price ? Math.round((compare - price) * 100 / compare) : 0;
      var codes = (i.line_level_discount_allocations || []).map(function (d) { return d.discount_application && d.discount_application.title; }).filter(Boolean);
      return '<div class="pc-cd-item" data-key="' + esc(i.key) + '">' +
        thumb(i.image, i.product_title) +
        '<div class="pc-cd-item-info">' +
          '<a class="pc-cd-item-title" href="' + esc(i.url) + '">' + esc(i.product_title) + '</a>' +
          (sub ? '<p class="pc-cd-item-variant">' + esc(sub) + '</p>' : '') +
          (pct > 0 ? '<p class="pc-cd-item-promo">Save ' + pct + '%</p>' : '') +
          codes.map(function (t) { return '<p class="pc-cd-item-extra">' + I.tag + esc(t) + '</p>'; }).join('') +
        '</div>' +
        '<div class="pc-cd-item-side">' +
          '<span class="pc-cd-current">' + fmt(price) + '</span>' +
          (compare > price ? '<span class="pc-cd-compare">' + fmt(compare) + '</span>' : '') +
          '<div class="pc-cd-qty">' +
            '<button type="button" data-q="' + (i.quantity - 1) + '" aria-label="Decrease quantity">' + I.minus + '</button>' +
            '<span class="pc-cd-qty-val">' + i.quantity + '</span>' +
            '<button type="button" data-q="' + (i.quantity + 1) + '" aria-label="Increase quantity">' + I.plus + '</button>' +
          '</div>' +
          '<button type="button" class="pc-cd-remove" data-q="0">Remove</button>' +
        '</div>' +
      '</div>';
    }).join('');

    list.querySelectorAll('.pc-cd-item').forEach(function (row) {
      row.querySelectorAll('[data-q]').forEach(function (b) {
        b.addEventListener('click', function () { change(row.getAttribute('data-key'), Math.max(0, parseInt(b.getAttribute('data-q'), 10))); });
      });
    });

    var savedEl = o.querySelector('.pc-cd-saved');
    savedEl.hidden = saved <= 0;
    savedEl.innerHTML = saved > 0 ? fmt(saved) + ' saved' : '';
    o.querySelector('.pc-cd-subtotal').innerHTML = fmt(cart.total_price, true);
    recs(cart, o);
  }

  function refresh(cart) {
    return withCompare(cart).then(render);
  }

  function change(key, qty) {
    var o = ensure();
    o.querySelector('.pc-cd-items').classList.add('is-busy');
    fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) })
      .then(function (r) { return r.json(); })
      .then(refresh)
      .catch(function () { o.querySelector('.pc-cd-items').classList.remove('is-busy'); });
  }

  /* ---------- "You might also like" ---------- */
  function recs(cart, o) {
    var wrap = o.querySelector('.pc-cd-recs');
    fetch('/recommendations/products.json?product_id=' + cart.items[0].product_id + '&limit=6&intent=related')
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var ps = (d && d.products || []).filter(function (p) { return !cart.items.some(function (i) { return i.product_id === p.id; }); });
        if (!ps.length) { wrap.hidden = true; return; }
        wrap.hidden = false;
        var track = wrap.querySelector('.pc-cd-recs-track'), dots = wrap.querySelector('.pc-cd-recs-dots');
        track.innerHTML = ''; dots.innerHTML = '';
        ps.forEach(function (p, n) {
          var v = p.variants && p.variants[0];
          var price = v ? v.price : p.price, cmp = v ? v.compare_at_price : 0;
          var card = document.createElement('div');
          card.className = 'pc-cd-rec-card';
          card.innerHTML = thumb(p.featured_image, p.title) +
            '<div class="pc-cd-rec-info"><p class="pc-cd-rec-rating">&#9733;&#9733;&#9733;&#9733;&#9733;</p>' +
            '<a class="pc-cd-rec-title" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
            '<p class="pc-cd-rec-sub">' + esc(p.type || '') + '</p></div>' +
            '<div class="pc-cd-rec-right"><span><span class="pc-cd-current">' + fmt(price) + '</span>' +
            (cmp > price ? '<br><span class="pc-cd-compare">' + fmt(cmp) + '</span>' : '') + '</span>' +
            '<button type="button" class="pc-cd-rec-add">Add</button></div>';
          card.querySelector('.pc-cd-rec-add').addEventListener('click', function (e) {
            if (!v) return;
            e.currentTarget.disabled = true;
            add(v.id, 1);
          });
          track.appendChild(card);
          var dot = document.createElement('span');
          if (!n) dot.className = 'is-active';
          dots.appendChild(dot);
        });
        dots.hidden = ps.length < 2;
        track.onscroll = function () {
          var w = track.firstChild ? track.firstChild.getBoundingClientRect().width + 10 : 1;
          var k = Math.round(track.scrollLeft / w);
          Array.prototype.forEach.call(dots.children, function (d, j) { d.className = j === k ? 'is-active' : ''; });
        };
      })
      .catch(function () { wrap.hidden = true; });
  }

  /* ---------- open / add ---------- */
  function open() {
    var o = ensure();
    o.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
    return fetch('/cart.js').then(function (r) { return r.json(); }).then(refresh);
  }
  function add(variantId, qty, properties) {
    var item = { id: variantId, quantity: qty || 1 };
    if (properties) item.properties = properties;
    return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [item] }) })
      .then(function (r) { return r.json(); })
      .then(open);
  }

  /* product page "Add to cart": add in the background and slide the drawer in */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.action || form.action.indexOf('/cart/add') < 0 || !form.closest('.pc-pd-buybox')) return;
    e.preventDefault();
    var fd = new FormData(form), props = {};
    fd.forEach(function (val, k) { var m = k.match(/^properties\[(.+)\]$/); if (m) props[m[1]] = val; });
    var btn = form.querySelector('[type="submit"]');
    if (btn) btn.disabled = true;
    add(fd.get('id'), parseInt(fd.get('quantity') || '1', 10), Object.keys(props).length ? props : null)
      .then(function () { if (btn) btn.disabled = false; }, function () { if (btn) btn.disabled = false; form.submit(); });
  });

  window.PCCartDrawer = { open: open, close: close, add: add };
})();
